<!--  -->
<template>
  <div class="feadcoantiner">
    <div class="usecheck">
      <p>问题反馈类型</p>
      <div class="itemlist">
        <div
          :class="code === index ? 'itemuser bofdr' : 'itemuser'"
          v-for="(item, index) in list"
          :key="index"
          @click="getid(index)"
        >
          <span>{{ item.name }}</span>
        </div>
      </div>
      <md-textarea-item
        ref="demo2"
        class="demo2"
        :autosize="true"
        v-model="value"
        :max-length="100"
        :max-height="250"
        placeholder="有使用不便、體驗不好或想給我們提意見？請儘管告知我們，非常感謝！"
      ></md-textarea-item>
      <ul class="image-reader-list">
        <li
          class="image-reader-item"
          v-for="(img, index) in imageList['reader0']"
          :key="index"
          :style="{
            backgroundImage: `url(${img})`,
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
          }"
        >
          <md-tag
            class="image-reader-item-del"
            size="small"
            shape="quarter"
            fill-color="#111A34"
            type="fill"
            font-color="#fff"
            @click.native="onDeleteImage('reader0', index)"
          >
            <md-icon name="close"></md-icon>
          </md-tag>
        </li>
        <li
          class="image-reader-item add"
          v-if="imageList['reader0'].length < 3"
        >
          <md-image-reader
            name="reader0"
            :is-camera-only="true"
            @select="onReaderSelect"
            @complete="onReaderComplete"
            @error="onReaderError"
            :is-multiple="true"
            :amount="3"
          ></md-image-reader>
          <md-icon name="camera" size="md" color="#CCC"></md-icon>
          <p>添加图片</p>
        </li>
      </ul>
      <md-input-item
        title="联系方式"
        type="phone"
        v-model="phone"
        placeholder="手机、微信等联系方式"
      ></md-input-item>
      <md-button type="warning" round class="buttoner" @click="hansubmit"
        >提交</md-button
      >
      <span class="fedxlinr" @click="fankuilsue">反馈记录</span>
      <div class="bainie"></div>
    </div>
  </div>
</template>

<script>
import {
  TextareaItem,
  Icon,
  InputItem,
  ImageReader,
  Button,
  Tag,
  Toast
} from "mand-mobile";
export default {
  name: "",
  components: {
    [TextareaItem.name]: TextareaItem,
    [Icon.name]: Icon,
    [InputItem.name]: InputItem,
    [ImageReader.name]: ImageReader,
    [Button.name]: Button,
    [Tag.name]: Tag
  },
  data() {
    return {
      code: null,
      value: "",
      phone: "",
      imgsrc: [],
      imageList: {
        reader0: []
      },
      list: [
        { name: "功能异常", id: 1 },
        { name: "體驗問題", id: 2 },
        { name: "建議意見", id: 3 },
        { name: "用户投诉", id: 0 },
        { name: "其他", id: 4 }
      ]
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  methods: {
    getid(id) {
      console.log(id);
      this.code = id;
    },
    onReaderSelect(name, { files }) {
      files.forEach(file => {
        console.log(
          "[Mand Mobile] ImageReader Selected:",
          "File Name " + file.name
        );
      });
      Toast.loading("图片读取中...");
    },
    onReaderComplete(name, { dataUrl, file }) {
      Toast.hide();
      console.log(this.imageList);
      console.log(file);
      const formData = new FormData();
      formData.append("file", file);
      this.http.APIASK(this.ports.osuploads, "post", formData).then(res => {
        console.log(res);
        let obj = { url: res[0] };
        this.imgsrc.push(obj);
      });
      setTimeout(() => {
        const demoImageList = this.imageList[name] || [];
        demoImageList.push(dataUrl);
        this.$set(this.imageList, name, demoImageList);
      }, 100);
    },
    onReaderError(name, { msg }) {
      Toast.failed(msg);
    },
    fankuilsue(){
      this.$router.push({name:'Fankuilist'})
    },
    hansubmit() {
      if (this.code === null) {
        Toast.failed("请选择反馈类型");
        return;
      }
      if (!this.value) {
        Toast.failed("请输入反馈内容");
        return;
      }
      if (!this.phone) {
        Toast.failed("请输入手机、微信等联系方式");
        return;
      }
      const par = {
        content:this.value,
        imgs: this.imgsrc,
        phone: this.phone,
        type: this.code
      };
      this.http.APIASK(this.ports.feedBack, "post", par).then(res => {
         Toast.succeed("感谢您的反馈，我们会持续为您提供更优质的服务");
         setTimeout(() => {
           this.$router.go(-1);
      }, 3000);
      });
      console.log(this.imgsrc);
    },
    onDeleteImage(name, index) {
      const demoImageList = this.imageList[name] || [];
      const userolit = this.imgsrc || [];
      demoImageList.splice(index, 1);
      this.imgsrc.splice(index, 1);
      this.$set(this.imageList, name, demoImageList);
    }
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {}
};
</script>
<style lang="less">
/* @import url(); 引入css类 */
.feadcoantiner {
  background-color: white;
  .usecheck {
    width: 96%;
    margin-left: 2%;
    p {
      font-size: 0.3rem;
      text-align: left;
      padding: 0.2rem 0;
    }
    .itemlist {
      display: flex;
      .itemuser {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.26rem;
        width: 1.4rem;
        height: 0.5rem;
        border: 1px solid #f2f2f2;
        margin-right: 0.2rem;
        border-radius: 0.08rem;
      }
      .bofdr {
        color: #e32c1a;
        border: 1px solid #e32c1a;
      }
    }
    .demo2 {
      margin-top: 0.2rem;

      border: 1px solid #f2f2f2;
      border-radius: 0.1rem;
    }
  }
  .image-reader-list {
    display: flex;
    width: 100%;
    margin-top: 0.5rem;
    flex-wrap: wrap;
    .image-reader-item {
      width: 2rem;
      position: relative;
      background: #fff;
      height: 2rem;
      margin-bottom: 0.4rem;
      margin-right: 0.4rem;
      box-shadow: 0 5px 20px rgba(197, 202, 213, 0.25);
      p {
        color: #ccc;
        position: absolute;
        top: 0.8rem;
        left: 0.4rem;
      }
      .image-reader-item-del {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
  .buttoner {
    height: 0.9rem;
    margin: 0.4rem 0;
  }
  .bainie {
    width: 100%;
    height: 5rem;
    background-color: white;
  }
}
.fedxlinr{
  font-size: 0.34rem;
  color: #2a78dc;
}
</style>
